import type { FaireProductEntity } from "../../entity_types/product";

export const p_na2sehfws4: FaireProductEntity = {
  token: "p_na2sehfws4",
  type: "product",
  name: "Farm to Table Recipe Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6b33687c262d1a6dbee2ab481948d6eab800bd2aa11ea465c792ebdec2294717.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/423572eb4eac2328dcdcc13c48d9d13b570ee30ba09591bab74251d56acdcc74.jpeg",
    "https://cdn.faire.com/fastly/3052fb29568da5b0a093f122a75a595d36192c249628d8d4aff2e8b5b5c3b303.jpeg",
  ],
  priceDollars: 7,
  description:
    "Let's go old school and trade recipes! A hand-written recipe card creates memories, legacies, even! Generations to come will know what yumminess you experienced, and what handwriting used to look like!\n\nSet of 12 recipe cards",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:00.833Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
